import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import IncidentFairnessEditTable from './IncidentFairnessEditTable';

const IncidentFairnessEditTableStandalone = props => (
  <Provider store={store}>
    <IncidentFairnessEditTable {...props} />
  </Provider>
);

export default IncidentFairnessEditTableStandalone;
